import React from 'react';
import { TextField, IconButton, Box, Autocomplete } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

const CustomSearchInputField = ({ value, onChange, onAdd, options = [], placeholder = 'Enter value...' }) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Autocomplete
        freeSolo
        disableClearable
        options={options}
        inputValue={value}
        onInputChange={(e, newVal) => onChange({ target: { value: newVal } })}
        renderInput={params => <TextField {...params} label={placeholder} variant="outlined" size="small" />}
        sx={{ flex: 1 }}
      />
      <IconButton onClick={onAdd} color="primary">
        <AddIcon />
      </IconButton>
    </Box>
  );
};

export default CustomSearchInputField;
